<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Группы устройств</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Создать группу</li>
        </ol>
    </nav>

    <div class="two-col-container">
        <div class="left-col">
            <div class="form-narrow">
                <div class="mb-4">
                    <label for="playlist-name" class="form-label">
                        Название группы <span class="color-red">*</span>
                    </label>
                    <input type="text" class="form-control" id="group-name" v-model="name" placeholder="Название" required>
                </div>

                <div class="mb-4">
                    <div class="form-label">Клиент <span class="color-red">*</span></div>
                    <v-select
                        v-model="client_id"
                        :items="clients"
                        @update:modelValue="onChangeClient"
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        clearable
                        density="compact">
                        <template #no-data>
                            <span>Данные не найдены</span>
                        </template>
                    </v-select>
                </div>

                <div class="mb-4">
                    <div class="form-label">Бренд <span class="color-red">*</span></div>
                    <v-select
                        :disabled="client_id ? false : true"
                        v-model="brand_id"
                        :items="brands"
                        @update:modelValue="onChangeBrand"
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        clearable
                        density="compact">
                        <template #no-data>
                            <span><span>Данные не найдены</span></span>
                        </template>
                    </v-select>
                </div>

                <div class="mb-4">
                    <div class="form-label">Тип устройства <span class="color-red">*</span></div>
                    <v-select
                        :disabled="client_id && brand_id ? false : true"
                        v-model="device_type"
                        :items="device_types"
                        @update:modelValue="onChangeDeviceType"
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        clearable
                        density="compact">
                        <template #no-data>
                            <span>Данные не найдены</span>
                        </template>
                    </v-select>
                </div>
            </div>

            <div class="form-narrow mb-3">
                <div class="tabs mb-2">
                    <div class="tabs__ctrls">
                        <button class="reset-btn tabs__ctrl local"
                                v-on:click.prevent="devices_by = 1"
                                :class="{ 'is-selected': devices_by === 1 }" type="button">
                            Список устройств
                        </button>
                        <button class="reset-btn tabs__ctrl cloud"
                                v-on:click.prevent="devices_by = 0"
                                :class="{ 'is-selected': devices_by === 0 }" type="button">
                            Список аптек
                        </button>

                        <button class="reset-btn tabs__ctrl cloud"
                                v-on:click.prevent="devices_by = 2"
                                :class="{ 'is-selected': devices_by === 2 }" type="button">
                            Регионы
                        </button>
                    </div>
                </div>

                <template v-if="devices_by === 1">
                    <div class="mb-4">
                        <div class="mb-4">
                            <select-back-searchable-element
                                @getItems="loadDevices"
                                @syncItems="syncDevices"
                                :backSearchableDisabled="backSearchableDisabled"
                                :loaded_items="devices_founded"
                                :picked_items="device_ids_new"
                                :pages="devices_pages">
                            </select-back-searchable-element>
                        </div>
                    </div>
                </template>

                <template v-if="devices_by === 0">
                    <div class="mb-3">
                        <input
                            v-bind:disabled="!brand_id && !device_type"
                            v-model="locations"
                            type="text"
                            class="form-control"
                            id="locations"
                            placeholder="Номера аптек через пробел 77-008 77-1500">
                    </div>
                </template>

                <template v-if="devices_by === 2">
                    <v-select
                        v-model="region"
                        :items="regions"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        multiple
                        clearable
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <span>Данные не найдены</span>
                        </template>
                        <template #selection="{ item, index }">
                            <v-chip v-if="index < 3" :text="item.title"></v-chip>
                            <span v-if="index === 3" class="text-grey text-caption align-self-center">
                                + еще {{ region.length - 3 }}
                            </span>
                        </template>
                    </v-select>
                </template>

                <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
                    <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createGroup"/>
                    <a class="btn btn-lg btn-grey btn-outline-dark" :href="route_back">Отменить</a>
                </div>
            </div>
        </div>

        <Transition name="fade">
            <div v-if="showSelectedDevices" class="right-col">
                <SelectedDevices
                    :devicesFounded="devices_founded"
                    v-model:deviceIds="device_ids_new"
                    v-model:regionIds="region"
                    v-model:locationNumbers="locations"
                    @stateChange="handleSelectedDevicesState"
                />
            </div>
        </Transition>
    </div>

    <Alert />
</template>

<script>
import SelectBackSearchableElement from "../../../../elements/SelectBackSearchableElement.vue";
import Group from '../../../../models/Group';
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import SelectedDevices from "../../../../elements/SelectedDevices.vue";

export default {
    name: "GroupCreateComponent",
    components: { Alert, SelectBackSearchableElement, ConfirmBtn, SelectedDevices },
    props: {
        route_back: String,
        route_client_search: String,
        route_brand_search: String,
        route_create: String,
        route_group: String,
        route_devices_search: String,
        route_get_devices_types: String,
        route_get_regions: String,
    },
    data() {
        return {
            group: new Group({
                route_update: this.route_update,
                route_get: this.route_get,
                route_brand_search: this.route_brand_search,
                route_client_search: this.route_client_search,
                route_device_groups_search: this.route_device_groups_search,
                route_devices_search: this.route_devices_search
            }),
            devices_founded: [],
            device_ids: [],
            device_ids_new: [],
            devices_changed: false,
            client_id: null,
            brand_id: null,
            clients: [],
            devices_by: 1,
            device_type: null,
            device_types: [],
            region: [],
            regions: '',
            locations: '',
            brands: [],
            devices: [],
            devices_pages: 1,
            numberPharmacy: '',
            city: '',
            address: '',
            selectedClientId: null,
            selectedBrandId: null,
            selectedDevices: [],
            name: '',
            selectedDefault: false,
            isOpenDropDown: false,
            search: null,
            showSelectedDevices: false
        }
    },
    computed: {
        backSearchableDisabled() {
            if (this.brand_id !== null && this.client_id !== null && this.device_type !== null) {
                this.loadDevices('', 9999, 1);
                return false;
            } else return true;
        },
        devicesSelected() {
            if (this.device_ids_new.length || this.region.length || this.locations.length) return true;
            else return false;
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),

        createGroup: async function () {
            if (this.name.trim() == '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название группы' });
                this.toggleLoading();
                return;
            }

            if (!this.client_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента' });
                this.toggleLoading();
                return;
            }

            if (!this.brand_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите бренд' });
                this.toggleLoading();
                return;
            }

            if (this.device_type == null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите тип устройства' });
                this.toggleLoading();
                return;
            }

            const result = await axios.post('/clients/device-groups/create', {
                client_id: this.client_id,
                brand_id: this.brand_id,
                device_ids: this.device_ids_new.map(el => el.id),
                name: this.name,
                default: this.selectedDefault,
                locations: this.locations,
                region_id: this.region,
                device_type_id: this.device_type
            }).then(response => {
                return response.data.status != undefined && response.data.status == 'ok';
            });

            if(result) {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось добавить группу что то пошло не так' });
                this.toggleLoading();
            }
        },
        syncDevices(devices) {
            this.device_ids_new = devices;
            this.devices_changed = true;
        },
        loadDevices: async function (search, limit, page) {
            if (!this.client_id || !this.brand_id || !this.device_type) {
                return;
            }
            let data = await this.group.devices({
                search: search,
                limit: limit,
                page: page,
                client_id: this.client_id,
                brand_id: this.brand_id,
                device_type_id: this.device_type
            });
            this.devices_founded = data.items;
            this.devices_pages = data.pages;
        },
        onChangeClient: async function() {
            this.devices = [];
            this.selectedDevices = [];
            this.brand_id = null;
            await this.getBrands();
        },
        onChangeBrand: async function () {
            this.devices = [];
            this.selectedDevices = [];
            this.device_type = null;
        },
        onChangeDeviceType: async function() {
            this.devices = [];
            this.selectedDevices = [];
            await this.loadDevices('', 9999, 1);
        },
        getClients: async function () {
            const clients = await axios.get('/clients/device-groups/get/clients')
                .then(response => {
                    if(response.data.items !== undefined && response.data.items.length > 0) {
                        return response.data.items;
                    }
                    return false;
            });

            if (clients) this.clients = clients;
        },
        getBrands: async function () {
            const brands = await axios.get('/clients/device-groups/get/brands', {
                params: { client_id: this.client_id }
            }).then(response => {
                if(response.data.items !== undefined && response.data.items.length > 0) {
                    return response.data.items;
                }
                return false;
            });

            if (brands) this.brands = brands;
            else this.brands = [];
        },
        getDevicesTypes: async function () {
            let data = await axios.get(this.route_get_devices_types, { params: { limit: 9999 } });
            this.device_types = data.data.items;
        },
        getRegions: async function () {
            let data = await axios.get(this.route_get_regions, { params: { limit: 9999 } });
            this.regions = data.data.items;
        },
        handleSelectedDevicesState(state) {
            this.showSelectedDevices = state;
        }
    },
    watch: {
        devicesSelected(val) {
            if (val) {
                this.showSelectedDevices = true;
            }
        },
        locations(val) {
            console.log(val);
            
        }
    },
    mounted() {
        this.getClients();
        this.getDevicesTypes();
        this.getRegions();        
    },
}
</script>

<style scoped>
.app-dropdown {
    border-radius: 5px;
    position: relative;
}

.app-dropdown .manager {
    border: 1px solid #ddd;
    border-radius: 4px;
}

.app-dropdown .items-block {
    position: relative;
    height: 200px;
    overflow: auto;
    z-index: 9999;
    background-color: #fff;
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.app-dropdown .items-block .searching-block {
    position: sticky;
    top: 0;
    background-color: #fff;
}

.app-dropdown .items-block .searching-block input {
    border-bottom: 1px solid #ddd;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
}

.app-dropdown .items {
    position: absolute;
    width: 100%;
}

.app-dropdown .items .item {
    padding: 0 10px;
    cursor: pointer;
    font-size: 16px;
}

.app-dropdown .items .item:hover {
    background-color: #3c7af0;
    color: white;
}

.app-dropdown .hidden {
    display: none;
}

.app-dropdown .manager {
    padding: 15px;
    height: 40px;
    cursor: pointer;
}

.app-dropdown .manager .button {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;
    background-position: center right;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
}

.app-dropdown .shade {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 999;
    min-height: 100vh;
    overflow: hidden;
}

.app-dropdown .content {
    position: absolute;
    width: 100%;
    height: 200px;
    top: -500%;
}

.app-dropdown .disable{
    background-color: #ddd;
    cursor: initial;
}
</style>
